export default __webpack_public_path__ + "static/media/cleanShirts.ec1f4376.jpg";